import { z } from 'zod';
import {
  openingPreviewSchema,
  openingRowSchema,
  type CreateOpeningInput,
  type OpeningPreview,
  type OpeningRow,
} from '@eombor/contracts';
import type { ApiClient } from '../../../shared/api/client.js';
import { apiClient } from '../../auth/model/auth.store.js';

/**
 * BOSHLANG'ICH QOLDIQ — API yuzasi.
 *
 * Yuklash IKKI so'rov: `preview` faylni faqat o'qiydi va satrlarni
 * qaytaradi, `create` esa yozadi. Bitta so'rovga birlashtirilsa, odam
 * ikki yuz satrni ko'rmasdan tasdiqlab yuborardi va uni orqaga
 * qaytarish hisobotlarni buzardi.
 *
 * `create` Excel ni UMUMAN bilmaydi: qo'lda kiritilgan satrlar ham shu
 * yerdan o'tadi. Fayl faqat satrlarni tayyorlaydi.
 */

export const openingPageSchema = z.object({
  items: z.array(openingRowSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export type OpeningPage = z.infer<typeof openingPageSchema>;

export interface OpeningApi {
  list: (query?: { page?: number; limit?: number }) => Promise<OpeningPage>;
  /** Faylni tekshiradi — hech narsa yozmasdan. */
  preview: (file: File) => Promise<OpeningPreview>;
  create: (input: CreateOpeningInput) => Promise<OpeningRow>;
  cancel: (id: string) => Promise<OpeningRow>;
}

const BASE = '/subdivisions/mine/openings';

export const createOpeningApi = (client: ApiClient): OpeningApi => ({
  list: (query = {}) => {
    const params = new URLSearchParams();
    params.set('page', String(query.page ?? 1));
    params.set('limit', String(query.limit ?? 20));
    return client.apiFetch(`${BASE}?${params.toString()}`, { schema: openingPageSchema });
  },

  /* Fayl `FormData` bilan ketadi va `Content-Type` QO'LDA qo'yilmaydi —
     brauzer `boundary` ni o'zi qo'shadi (`supply.api.ts` bilan ayni sabab). */
  preview: (file) => {
    const form = new FormData();
    form.append('file', file);
    return client.apiFetch(`${BASE}/preview`, {
      method: 'POST',
      body: form,
      schema: openingPreviewSchema,
    });
  },

  create: (input) =>
    client.apiFetch(BASE, {
      method: 'POST',
      body: JSON.stringify(input),
      schema: openingRowSchema,
    }),

  cancel: (id) =>
    client.apiFetch(`${BASE}/${id}/cancel`, { method: 'POST', schema: openingRowSchema }),
});

export const openingApi = createOpeningApi(apiClient);
